export default __webpack_public_path__ + "static/media/milkyway.8aafe737.hdr";